import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import RouterApp from './RouterApp';
import reportWebVitals from './reportWebVitals';
import { SpeedInsights } from '@vercel/speed-insights/react';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterApp />
     <SpeedInsights />
  </React.StrictMode>
);

reportWebVitals();
